import { render, staticRenderFns } from "./decision.vue?vue&type=template&id=2f2e520e&scoped=true&"
import script from "./decision.vue?vue&type=script&lang=ts&"
export * from "./decision.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2e520e",
  null
  
)

export default component.exports